import React, { useState, useEffect, FormEvent } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import DeviceSelectionScreen from './DeviceSelectionScreen/DeviceSelectionScreen';
import IntroContainer from '../IntroContainer/IntroContainer';
import MediaErrorSnackbar from './MediaErrorSnackbar/MediaErrorSnackbar';
import RoomNameScreen from './RoomNameScreen/RoomNameScreen';
import { useAppState } from '../../state';
import { useParams, useLocation } from 'react-router-dom';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { makeStyles, Typography, Grid, Button, Theme, Hidden, Switch, Tooltip } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import axios from 'axios';
import DialogContent from '@material-ui/core/DialogContent';
export enum Steps {
  roomNameStep,
  deviceSelectionStep,
}

export default function PreJoinScreens() {
  const { search, state } = useLocation();

  const searchParams = new URLSearchParams(search);

  const { user } = useAppState();
  const { getAudioAndVideoTracks } = useVideoContext();
  const { URLRoomName } = useParams<{ URLRoomName?: string }>();
  const [step, setStep] = useState(Steps.roomNameStep);

  const [name, setName] = useState<string>(user?.displayName || '');
  const [roomName, setRoomName] = useState<string>('');
  const [MessageForUser, SetMessageForUser] = useState('Loading');

  const [mediaError, setMediaError] = useState<Error>();
  const [OpenCallOrSmsModal, SetOpenCallOrSmsModal] = useState(false);

  useEffect(() => {
    if (URLRoomName) {
      setRoomName(URLRoomName);

      if (state) {
        const ContactPhoneNumber = (state as { state: { ContactPhoneNumber: string } }).state.ContactPhoneNumber;
        const RecordId = (state as { state: { RecordId: string } }).state.RecordId;
        const ContactName = (state as { state: { ContactName: string } }).state.ContactName;
        const ProviderId = (state as { state: { ProviderId: string } }).state.ProviderId;
        const Type = (state as { state: { Type: string } }).state.Type;
        const providerName = (state as { state: { providerName: string } }).state.providerName;
        // alert(param);
        //console.log(Type);
        if (Type == 'Host') {
          setName(providerName);
        }
        if (Type == 'Patient') {
          setName(ContactName);
        }
        //console.log(mediaError);
        // window.history.replaceState(null, '', window.encodeURI(`/room/${roomName}${window.location.search || ''}`));
        getAudioAndVideoTracks().catch(error => {
          SetMessageForUser('Error acquiring local media:');
          //console.log('Error acquiring local media:');
          console.dir(error);
          setMediaError(error);
        });
        setStep(Steps.deviceSelectionStep);
      } else {
        SetMessageForUser('Error joining meeting');
      }
      if (state == undefined) {
        SetMessageForUser('Invalid meeting link');
      }
      //console.log(state);
      if (URLRoomName && state == undefined) {
        SetMessageForUser('There is a problem on the meeting link kindly join with the original provided link');
      }
      // if (user?.displayName) {
      //   setStep(Steps.deviceSelectionStep);
      // }
    } else if (search) {
      SetMessageForUser('Loading wait');
    } else {
      SetMessageForUser('Invalid meeting link');
    }
  }, [URLRoomName, user]);

  useEffect(() => {
    if (step === Steps.deviceSelectionStep && !mediaError) {
      getAudioAndVideoTracks().catch(error => {
        //console.log('Error acquiring local media:');
        console.dir(error);

        setMediaError(error);
      });
    }
  }, [getAudioAndVideoTracks, step, mediaError]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    // If this app is deployed as a twilio function, don't change the URL because routing isn't supported.
    // @ts-ignore
    if (!window.location.origin.includes('twil.io') && !window.STORYBOOK_ENV) {
      window.history.replaceState(null, '', window.encodeURI(`/room/${roomName}${window.location.search || ''}`));
    }
    setStep(Steps.deviceSelectionStep);
  };
  //   <Grid container justifyContent="center" alignItems="center" direction="column" style={{ height: '100%' }}>
  //   <div>
  //     <CircularProgress variant="indeterminate" />
  //   </div>
  //   <div>
  //     {/* <LocalVideoPreview identity={name} />
  //     <ToggleAudioButton className={classes.mobileButton} disabled={disableButtons} />
  //     <ToggleVideoButton className={classes.mobileButton} disabled={disableButtons} /> */}
  //     <Typography variant="body2" style={{ fontWeight: 'bold', fontSize: '16px' }}>
  //       Setting Up
  //     </Typography>
  //   </div>
  // </Grid>

  return (
    <IntroContainer>
      <MediaErrorSnackbar error={mediaError} />
      {!URLRoomName || roomName?.length > 0 || !name ? (
        <div>
          {' '}
          {step === Steps.deviceSelectionStep ? (
            ''
          ) : (
            <Grid container justifyContent="center" alignItems="center" direction="column" style={{ height: '100%' }}>
              <div>
                <CircularProgress variant="indeterminate" />
              </div>
              <div>
                {/* <LocalVideoPreview identity={name} />
          <ToggleAudioButton className={classes.mobileButton} disabled={disableButtons} />
          <ToggleVideoButton className={classes.mobileButton} disabled={disableButtons} /> */}
                <Typography variant="body2" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                  {MessageForUser}
                </Typography>
              </div>
            </Grid>
          )}
        </div>
      ) : (
        step === Steps.roomNameStep && (
          <RoomNameScreen
            name={name}
            roomName={roomName}
            setName={setName}
            setRoomName={setRoomName}
            handleSubmit={handleSubmit}
          />
        )
      )}
      {step === Steps.deviceSelectionStep && (
        <DeviceSelectionScreen name={name} roomName={roomName} setStep={setStep} />
      )}
    </IntroContainer>
  );
}
